/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { ArticlePageContentContainer, ArticlePageLeftMenu, ArticlePageWrapper } from './components';

export const ArticlePageContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  return (
    <ArticlePageWrapper>
      <ArticlePageLeftMenu />
      <ArticlePageContentContainer>
        {children}
      </ArticlePageContentContainer>
    </ArticlePageWrapper>
  );
};
